import React from 'react'
import WithdrawInfoPopup from '@bet25/ui/WithdrawInfoPopup'
import UserAdapter from '../../common/adapters/UserAdapter'
import { ModalService } from 'services/ModalService'

const WithdrawMitIdPopup = ({ data }) => {
    const onCloseModal = () => {
        ModalService.closeModal('WITHDRAW_MIT_ID_POPUP')
    }

    const onConfirm = () => {
        UserAdapter.loginMitIdElevate()
            .then((result) => {
                if (result.success) {
                    window.location.href = result.data
                } else {
                    console.log('Error', result.errorMessage)
                }
            })
            .catch((e) => {
                Notification.error('', 'Noget gik galt')
            })
            .finally(() => {
                onCloseModal()
            })
    }

    return (
        <WithdrawInfoPopup
            currentTheme={'dark'}
            onCloseModal={onCloseModal}
            onConfirm={onConfirm}
            popupType={'MIT_ID_REDIRECT'}
        />
    )
}

export default WithdrawMitIdPopup
